import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
// import CryptoJS from "crypto-js";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
const secretKey = process.env.REACT_APP_SECRET_KEY || "default-fallback-key";
const API_URL = process.env.REACT_APP_API_URL;
const API_FILE = process.env.REACT_APP_FILE_URL;
const URL = process.env.PUBLIC_URL;

type Detail = {
    id: number;
    no: number;
    note: string | null;
    files?: string[];
    comments?: Comment[];
    user_check: 0 | 1;
    admin_check?: 0 | 1;
};

type Comment = {
    id: number;
    comment: string;
};

type Drawing = {
    id: number;
    note: string | null;
    coordinates: any[];
    details: Detail[];
    // files?: string | null;
};

type SlideBarProps = {
    drawings: Drawing[];
    loading: boolean;
    reload: () => void;
    setScrollIndex: React.Dispatch<React.SetStateAction<number | null>>;
};

type Coordinate = {
    x: number;
    y: number;
    w: number;
    h: number;
    note?: string;
    detailId?: number;
    drawingId?: number;
};

export default function SlideBar({ drawings, loading, reload, setScrollIndex }: SlideBarProps) {
    // const [filesMap, setFilesMap] = useState<{ [key: number]: File[] }>({});
    // const [data, setData] = useState<any>(null);
    // const [loading, setLoading] = useState(true);
    // const [filter, setFilter] = useState(null);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [collapse, setCollapsed] = useState(false);
    const [filter, setFilter] = useState<"done" | "notdone" | null>(null);
    const location = useLocation();
    const isDetailPage = /^\/detail\/[^/]+$/.test(location.pathname);
    const { id } = useParams();
    const allDetails = drawings?.flatMap(drawing => drawing.details) || [];
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [commentsByDetail, setCommentsByDetail] = useState<Record<number, string[]>>({});
    const commentRefs = useRef<Record<number, HTMLDivElement | null>>({});
    const [openComment, setOpenComment] = useState<Record<number, boolean>>({});
    const handleTextarea = () => {
        const el = textareaRef.current;
        if (!el) return;

        el.style.height = "auto";
        el.style.height = `${el.scrollHeight}px`;
    };

    // if (id) {
    //     try {
    //         const bytes = CryptoJS.AES.decrypt(decodeURIComponent(id), secretKey);
    //         id = bytes.toString(CryptoJS.enc.Utf8);
    //     } catch (e) {
    //         console.error("Decrypt error:", e);
    //     }
    // }

    const filteredDetails = allDetails.filter(item => {
        if (filter === "done") return item.user_check === 1;
        if (filter === "notdone") return item.user_check === 0 || item.user_check === null;
        return true;
    });

    const handleUserClick = async (id: number) => {
        try {
            const resUser = await fetch(`${API_URL}/detail-user-check/${id}`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
            });

            if (!resUser.ok) {
                throw new Error(`Error ${resUser.status}`);
            }

            const data = await resUser.json();
            if (data.success) {
                reload();
            }

        } catch (error) {
            console.error("Fetch error:", error);
        }
    };

    const handleAdminClick = async (id: number) => {
        // if (isDetailPage) return;

        try {
            const res = await fetch(`${API_URL}/detail-admin-check/${id}`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify({ id }),
            });

            if (!res.ok) {
                throw new Error(`Error ${res.status}`);
            }

            const data = await res.json();
            if (data.success) {
                reload();
            }
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };

    const handleFileChange = async (
        e: React.ChangeEvent<HTMLInputElement>,
        detailId: number
    ) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        const formData = new FormData();
        for (const file of files) {
            formData.append("files[]", file);
        }
        formData.append("detail_id", String(detailId));

        try {
            Swal.fire({
                title: "Đang upload file...",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            const res = await fetch(`${API_URL}/detail-upload-file`, {
                method: "POST",
                body: formData,
                credentials: "include",
            });

            if (!res.ok) {
                throw new Error("Upload failed");
            }

            const result = await res.json();
            console.log("Upload result:", result);

            await Swal.fire({
                icon: "success",
                title: "Upload thành công",
                timer: 1200,
                showConfirmButton: false,
            });

            reload();

        } catch (err) {
            console.error("Upload error:", err);

            await Swal.fire({
                icon: "error",
                title: "Upload thất bại",
                text: "Không thể upload file",
            });
        }
    };

    const handleShare = async (id: string) => {
        try {
            const currentUrl = window.location.href;
            const shareUrl = currentUrl.replace("/edit/", "/detail/");

            await navigator.clipboard.writeText(shareUrl);

            Swal.fire({
                icon: "success",
                title: "Đã copy!",
                text: "Link chia sẻ đã được copy vào clipboard.",
                showConfirmButton: false,
                timer: 2000
            });
        } catch (err) {
            console.error("Copy error: ", err);

            Swal.fire({
                icon: "error",
                title: "Lỗi",
                text: "Không thể copy link!",
                confirmButtonText: "OK"
            });
        }
    };

    const handleUploadComments = async (detailId: number, comments: string[]) => {
        if (!comments || comments.length === 0) return;

        const payload = {
            detail_id: detailId,
            comments: comments.filter(c => c.trim() !== ""),
        };

        try {
            Swal.fire({
                title: "Đang gửi bình luận...",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            const res = await fetch(`${API_URL}/upload-comments`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (!data.success) {
                await Swal.fire({
                    icon: "error",
                    title: "Thất bại",
                    text: data.message || "Không thể gửi bình luận",
                });
                return;
            }

            await Swal.fire({
                icon: "success",
                title: "Đã gửi bình luận",
                timer: 1500,
                showConfirmButton: false,
            });

        } catch (err) {
            console.error("Upload comments error:", err);

            await Swal.fire({
                icon: "error",
                title: "Lỗi",
                text: "Lỗi khi gửi bình luận",
            });
        }
    };

    const handleDeleteDetail = async (id: number) => {
        const confirm = await Swal.fire({
            title: "Xác nhận xóa?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Xóa",
            cancelButtonText: "Hủy",
        });

        if (!confirm.isConfirmed) return;

        try {
            Swal.fire({
                title: "Đang xóa...",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            const updatedDrawing = drawings.map(drawing => {
                const detailIndex = drawing.details.findIndex(d => d.id === id);

                const coords: Coordinate[] =
                    Array.isArray(drawing.coordinates)
                        ? drawing.coordinates
                        : typeof drawing.coordinates === "string"
                            ? JSON.parse(drawing.coordinates)
                            : [];

                const isDeleteNullDetail = id == null;

                const filteredCoordinates = coords.filter(c => {
                    // 🟥 CASE 1: xóa hình KHÔNG có detailId
                    if (isDeleteNullDetail) {
                        return c.detailId != null; // ❌ xóa toàn bộ detailId = null
                    }

                    // 🟩 CASE 2: xóa detail CÓ id
                    if (c.detailId == null) return true; // giữ lại
                    return Number(c.detailId) !== Number(id);
                });

                // 🟥 Không có detail → chỉ xử lý coordinates
                if (detailIndex === -1) {
                    return {
                        ...drawing,
                        coordinates: filteredCoordinates,
                    };
                }

                // 🟩 Có detail → xóa detail + coordinates liên quan
                return {
                    ...drawing,
                    details: drawing.details.filter(d => d.id !== id),
                    coordinates: filteredCoordinates,
                };
            });

            const payload = {
                drawings: updatedDrawing.map(d => ({
                    ...d,
                    coordinates: JSON.stringify(d.coordinates ?? []),
                })),
            };

            // console.log("🚀 FINAL PAYLOAD:", payload);
            const res = await fetch(`${API_URL}/delete-detail/${id}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    payload,
                    drawn_shapes: drawings?.[0]?.id,
                }),
            });

            const data = await res.json();

            if (!data.success) {
                throw new Error("Delete failed");
            }

            await Swal.fire({
                icon: "success",
                title: "Đã xóa!",
                timer: 1200,
                showConfirmButton: false,
            });

            reload();

        } catch (err) {
            console.error(err);

            await Swal.fire({
                icon: "error",
                title: "Xóa thất bại!",
                text: "Không thể xóa dữ liệu",
            });
        }
    };

    useEffect(() => {
        if (!filteredDetails.length) return;

        setCommentsByDetail(prev => {
            if (Object.keys(prev).length > 0) return prev; // tránh reset lại

            const init: Record<number, string[]> = {};

            filteredDetails.forEach(d => {
                init[d.id] = d.comments?.map(c => c.comment) || [];
            });

            return init;
        });
    }, [filteredDetails]);

    useEffect(() => {
        Object.entries(openComment).forEach(([id, isOpen]) => {
            if (isOpen) {
                commentRefs.current[Number(id)]?.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
        });
    }, [openComment]);

    useEffect(() => {
        const init: Record<number, boolean> = {};

        Object.entries(commentsByDetail).forEach(([id, comments]) => {
            if ((comments?.length ?? 0) > 0) {
                init[Number(id)] = true;
            }
        });

        setOpenComment(prev => ({
            ...prev,
            ...init,
        }));
    }, [commentsByDetail]);

    return (
        <div className="slide-bar">
            <div className="slide-bar__option">
                <div
                    className={`slide-bar__option__collapse slide-bar__option--item ${collapse ? "active" : ""
                        }`}
                    onClick={() => setCollapsed(!collapse)}
                >
                    <i className="fa-solid fa-angles-left"></i>
                    <p className="close">Đóng</p>
                    <p className="open hidden">Mở</p>
                </div>

                <div
                    className={`slide-bar__option__uncheck slide-bar__option--item ${filter === "notdone" ? "active" : ""}`}
                    onClick={() => setFilter(prev => prev === "notdone" ? null : "notdone")}
                >
                    <i className="fa-solid fa-xmark"></i>
                    <p>Chưa làm</p>
                </div>

                <div
                    className={`slide-bar__option__check slide-bar__option--item ${filter === "done" ? "active" : ""}`}
                    onClick={() => setFilter(prev => prev === "done" ? null : "done")}
                >
                    <i className="fa-solid fa-check"></i>
                    <p>Đã làm</p>
                </div>

                <div className="slide-bar__option__share" onClick={() => {
                    if (id) handleShare(id);
                }}>
                    <i className="fa-solid fa-share-nodes"></i>
                    <p>Chia sẻ</p>
                </div>
            </div>

            <div className={`slide-bar__list ${collapse ? "hidden" : ""}`}>
                {filteredDetails.length > 0 ? (
                    filteredDetails.map((detail, index) => (
                        <div className="slide-bar__list__item"
                            key={detail.id}
                            onClick={() => {
                                setScrollIndex(null);
                                setTimeout(() => setScrollIndex(detail.id), 0);
                            }}
                        >
                            <div className="slide-bar__list__item__no">
                                <p>{detail.no ?? String(index + 1).padStart(2, "0")}</p>
                            </div>

                            <div className="slide-bar__list__item__note">
                                <p className="whitespace-pre-line break-words">{detail.note || ""}</p>
                            </div>

                            <div className="slide-bar__list__item__group h-10">
                                <div
                                    className={`relative group inline-flex items-center user-check 
                                                ${detail.user_check === 1 ? "active" : ""}
                                            `}
                                    onClick={() => handleUserClick(detail.id)}
                                >
                                    <i className="fa-solid fa-square-check fa-lg"></i>

                                    {/* Tooltip */}
                                    <span
                                        className="
                                            absolute -top-14 left-1/2 -translate-x-1/2
                                            rounded-md bg-green-600 px-5 py-1
                                            text-xl text-white whitespace-nowrap
                                            opacity-0 invisible
                                            group-hover:opacity-100 group-hover:visible group-hover:z-9
                                            transition-all duration-200
                                            pointer-events-none
                                        "
                                    >
                                        Đã làm
                                    </span>
                                </div>


                                <div
                                    className={`
                                                relative group inline-flex items-center ml-2 admin-check
                                                ${detail.admin_check === 1 ? "active" : ""}
                                            `}
                                    onClick={() => handleAdminClick(detail.id)}
                                >
                                    <i className="fa-solid fa-square-check fa-lg"></i>

                                    {/* Tooltip */}
                                    <span
                                        className="
                                            absolute -top-14 left-0 -translate-x-1/2
                                            rounded-md bg-green-600 px-5 py-1
                                            text-xl text-white whitespace-nowrap
                                            opacity-0 invisible
                                            group-hover:opacity-100 group-hover:visible group-hover:z-9
                                            transition-all duration-200
                                            pointer-events-none
                                        "
                                    >
                                        Đã kiểm tra
                                    </span>
                                </div>
                            </div>

                            {isDetailPage && (commentsByDetail[detail.id]?.length ?? 0) > 0 && (
                                <><hr className="mt-2" /></>
                            )}

                            <div
                                className={`overflow-hidden transition-all duration-300 
                                    ${openComment[detail.id] ? "max-h-[500px]" : "max-h-0"}
                                `}
                            >
                                {(commentsByDetail[detail.id] || []).map((comment, cIndex) => (
                                    <div
                                        key={cIndex}
                                        className={`${!isDetailPage ? 'w-full bg-white border rounded shadow px-2 py-3 flex gap-2' : 'text-xl text-gray-500 font-medium'} mt-2`}
                                        onClick={(e) => e.stopPropagation()}
                                        ref={(el) => {
                                            commentRefs.current[detail.id] = el;
                                        }}
                                    >
                                        {!isDetailPage && (
                                            <textarea
                                                className="flex-1 border rounded p-2 text-xl resize-none overflow-hidden"
                                                rows={3}
                                                value={comment}
                                                ref={textareaRef}
                                                onInput={handleTextarea}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setCommentsByDetail(prev => ({
                                                        ...prev,
                                                        [detail.id]: prev[detail.id].map((c, i) =>
                                                            i === cIndex ? value : c
                                                        ),
                                                    }));
                                                }}
                                            />
                                        )}

                                        {isDetailPage && (
                                            <p>{comment}</p>
                                        )}
                                        {!isDetailPage && (
                                            <button
                                                className="text-red-500"
                                                onClick={() => {
                                                    setCommentsByDetail(prev => ({
                                                        ...prev,
                                                        [detail.id]: prev[detail.id].filter((_, i) => i !== cIndex),
                                                    }));
                                                }}
                                            >
                                                <i className="fa-solid fa-xmark"></i>
                                            </button>
                                        )}

                                    </div>
                                ))}
                            </div>

                            <div className="flex mt-4 justify-between gap-6">
                                {!isDetailPage && (commentsByDetail[detail.id]?.length ?? 0) > 0 && (
                                    <div className="flex gap-6">
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleUploadComments(detail.id, commentsByDetail[detail.id]);
                                            }}
                                            className="bg-[#22a922] rounded-lg px-3 text-white py-3 text-xl relative group"
                                        >
                                            <i className="fa-solid fa-floppy-disk fa-lg"></i>
                                            <span
                                                className="
                                                    absolute -top-12 left-1/2 -translate-x-1/2
                                                    rounded-md bg-green-600 px-5 py-1
                                                    text-xl text-white whitespace-nowrap
                                                    opacity-0 invisible
                                                    group-hover:opacity-100 group-hover:visible group-hover:z-9
                                                    transition-all duration-200
                                                    pointer-events-none
                                                "
                                            >
                                                Lưu
                                            </span>
                                        </button>
                                        <div
                                            onClick={() => {
                                                setCommentsByDetail(prev => ({
                                                    ...prev,
                                                    [detail.id]: [...(prev[detail.id] || []), ""],
                                                }));
                                            }}
                                            className="ic !bg-blue-500 flex justify-center items-center cursor-pointer rounded-lg px-3 text-white py-3 relative group"
                                        >
                                            <i className="fa-solid fa-add"></i>
                                            {/* Tooltip */}
                                            <span
                                                className="
                                                        absolute -top-12 left-1/2 -translate-x-1/2
                                                        rounded-md bg-green-600 px-5 py-1
                                                        text-xl text-white whitespace-nowrap
                                                        opacity-0 invisible
                                                        group-hover:opacity-100 group-hover:visible group-hover:z-9
                                                        transition-all duration-200
                                                        pointer-events-none
                                                    "
                                            >
                                                Thêm comment
                                            </span>
                                        </div>
                                    </div>
                                )}

                                {(commentsByDetail[detail.id]?.length ?? 0) > 0 && (
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenComment(prev => ({
                                                ...prev,
                                                [detail.id]: !prev[detail.id]
                                            }));
                                        }}
                                        className="text-blue-600 flex items-center gap-1"
                                    >
                                        {openComment[detail.id] ? "Ẩn" : "Hiện"}

                                        <i
                                            className={`fa-solid fa-xs ${openComment[detail.id]
                                                ? "fa-chevron-up"
                                                : "fa-chevron-down"
                                                }`}
                                        />
                                    </button>
                                )}
                            </div>

                            <div className="slide-bar__list__item__file !mt-8">
                                {!isDetailPage && (
                                    <div className="flex justify-between">
                                        <div className="flex gap-4">
                                            <div className="ic w-[4rem] h-[3.5rem] relative group" onClick={() => document.getElementById(`file-input-${detail.id}`)?.click()}>
                                                <i className="fa-solid fa-upload"></i>
                                                <input
                                                    id={`file-input-${detail.id}`}
                                                    type="file"
                                                    className="hidden"
                                                    multiple
                                                    onChange={(e) => handleFileChange(e, detail.id)}
                                                />
                                                {/* Tooltip */}
                                                <span
                                                    className="
                                                        absolute -top-12 -left-4
                                                        rounded-md bg-green-600 px-5 py-1
                                                        text-xl text-white whitespace-nowrap
                                                        opacity-0 invisible
                                                        group-hover:opacity-100 group-hover:visible group-hover:z-9
                                                        transition-all duration-200
                                                        pointer-events-none
                                                    "
                                                >
                                                    Upload file
                                                </span>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    setOpenComment(prev => ({
                                                        ...prev,
                                                        [detail.id]: !prev[detail.id]
                                                    }));
                                                    setCommentsByDetail(prev => ({
                                                        ...prev,
                                                        [detail.id]: [...(prev[detail.id] || []), ""],
                                                    }));
                                                }}
                                                className="ic !bg-blue-500 w-[4rem] h-[3.5rem] cursor-pointer relative group"
                                            >
                                                <i className="fa-solid fa-comments"></i>
                                                {/* Tooltip */}
                                                <span
                                                    className="
                                                        absolute -top-12 left-1/2 -translate-x-1/2
                                                        rounded-md bg-green-600 px-5 py-1
                                                        text-xl text-white whitespace-nowrap
                                                        opacity-0 invisible
                                                        group-hover:opacity-100 group-hover:visible group-hover:z-9
                                                        transition-all duration-200
                                                        pointer-events-none
                                                    "
                                                >
                                                    Thêm comment
                                                </span>
                                            </div>
                                        </div>

                                        <div
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteDetail(detail.id);
                                            }}
                                            className="ic !bg-red-500 w-[4rem] h-[3.5rem] relative group">
                                            <i className="fa-solid fa-trash"></i>
                                            {/* Tooltip */}
                                            <span
                                                className="
                                                        absolute -top-12 -left-4
                                                        rounded-md bg-red-500 px-5 py-1
                                                        text-xl text-white whitespace-nowrap
                                                        opacity-0 invisible
                                                        group-hover:opacity-100 group-hover:visible group-hover:z-9
                                                        transition-all duration-200
                                                        pointer-events-none
                                                    "
                                            >
                                                Xóa
                                            </span>
                                        </div>

                                    </div>
                                )}

                                {detail.files?.map((f: any) => (
                                    <a key={f.id} href={`${API_FILE}/${f.file}`} target="_blank" rel="noreferrer" className="name break-words">
                                        <p>File đính kèm: <span>{f.file.split("/").pop()}</span></p>
                                    </a>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-center text-gray-500 mt-10">Không có chi tiết nào!</p>
                )}
            </div>

            {loadingSubmit && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
                    <div className="w-16 h-16 border-4 border-t-transparent border-white rounded-full animate-spin"></div>
                </div>
            )}
        </div>
    );
}
